import React, { useMemo, useState, useContext, createContext } from "react";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";

export const DragNDropContext = createContext();

export const DragNDropProvider = ({ children }) => {
  const [isDragging, setIsDragging] = useState(false);

  const value = useMemo(
    () => ({
      isDragging,
      setIsDragging,
    }),
    [isDragging]
  );

  return (
    <DragNDropContext.Provider value={value}>
      <DndProvider backend={HTML5Backend}>{children}</DndProvider>
    </DragNDropContext.Provider>
  );
};

export const useDragNDrop = () => useContext(DragNDropContext);
